<template>
  <div>
    <div class="flex items-center">
      <div class="flex-1 px-4">
        {{ form.name }}
      </div>
      <div class="px-4 flex">
        <button class="btn btn-ghost px-3" @click="showMore = !showMore">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="fill-current"
          >
            <path
              v-if="showMore"
              d="M6.71 14.71C6.80251 14.8027 6.9124 14.8762 7.03338 14.9264C7.15435
              14.9766 7.28403 15.0024 7.415 15.0024C7.54597 15.0024 7.67565 14.9766
              7.79662 14.9264C7.9176 14.8762 8.02749 14.8027 8.12 14.71L12 10.83L15.88
              14.71C15.9726 14.8026 16.0825 14.876 16.2035 14.9261C16.3244 14.9762
              16.4541 15.002 16.585 15.002C16.7159 15.002 16.8456 14.9762 16.9665
              14.9261C17.0875 14.876 17.1974 14.8026 17.29 14.71C17.3826 14.6174
              17.456 14.5075 17.5061 14.3865C17.5562 14.2656 17.582 14.1359 17.582
              14.005C17.582 13.8741 17.5562 13.7444 17.5061 13.6235C17.456 13.5025
              17.3826 13.3926 17.29 13.3L12.7 8.71C12.6075 8.61729 12.4976 8.54375
              12.3766 8.49356C12.2557 8.44338 12.126 8.41755 11.995 8.41755C11.864
              8.41755 11.7343 8.44338 11.6134 8.49356C11.4924 8.54375 11.3825 8.61729
              11.29 8.71L6.7 13.3C6.32 13.68 6.32 14.32 6.71 14.71Z"
            />
            <path
              v-else
              d="M17.29 9.29C17.1975 9.1973 17.0876 9.12375 16.9666 9.07357C16.8457
              9.02339 16.716 8.99756 16.585 8.99756C16.454 8.99756 16.3243 9.02339
              16.2034 9.07357C16.0824 9.12375 15.9725 9.1973 15.88 9.29L12 13.17L8.12
              9.29C8.02742 9.19742 7.91751 9.12398 7.79654 9.07388C7.67558 9.02377
              7.54593 8.99798 7.415 8.99798C7.28407 8.99798 7.15442 9.02377 7.03346
              9.07388C6.91249 9.12398 6.80258 9.19742 6.71 9.29C6.61742 9.38258
              6.54398 9.4925 6.49387 9.61346C6.44377 9.73442 6.41798 9.86407 6.41798
              9.995C6.41798 10.1259 6.44377 10.2556 6.49387 10.3765C6.54398 10.4975
              6.61742 10.6074 6.71 10.7L11.3 15.29C11.3925 15.3827 11.5024 15.4563 11.6234
              15.5064C11.7444 15.5566 11.874 15.5824 12.005 15.5824C12.136 15.5824
              12.2657 15.5566 12.3866 15.5064C12.5076 15.4563 12.6175 15.3827 12.71
              15.29L17.3 10.7C17.68 10.32 17.68 9.68 17.29 9.29Z"
            />
          </svg>
        </button>

        <VDropdown v-if="$membershipHasPermissionTo('edit forms,delete forms')" right class="ml-2">
          <template #button="dropdownProps">
            <button class="btn btn-ghost px-3" @click="dropdownProps.open">
              <FontAwesomeIcon icon="ellipsis-v" fixed-width />
            </button>
          </template>

          <template #default="dropdownProps">
            <VDropdownMenu>
              <a
                v-if="$membershipHasPermissionTo('edit forms')"
                role="button"
                :class="[
                  'block',
                  'px-4',
                  'py-2',
                  'hover:bg-gray-200',
                  'transition-color',
                  'transition-fast',
                  'text-right',
                ]"
                @click="dropdownProps.close(() => $emit('form-edit', form))"
                >Edit</a
              >
              <a
                v-if="$membershipHasPermissionTo('delete forms')"
                role="button"
                :class="[
                  'block',
                  'px-4',
                  'py-2',
                  'hover:bg-gray-200',
                  'transition-color',
                  'transition-fast',
                  'text-right',
                ]"
                @click="dropdownProps.close(() => $emit('form-delete', form))"
                >Remove</a
              >
            </VDropdownMenu>
          </template>
        </VDropdown>
      </div>
    </div>
    <div v-if="showMore" class="flex px-4 mt-4 bg-gray-800">
      <ul class="py-4 w-full">
        <li>
          <h5 class="text-base text-white">Submit URL</h5>
          <span class="text-gray-500">{{ submitUrl }}</span>
        </li>
        <li class="mt-4">
          <h5 class="text-base text-white">Json Structure</h5>
          <p class="whitespace-pre-wrap text-gray-500 font-mono">
            {{ jsonStructure }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';

export default {
  components: {
    VDropdown,
    VDropdownMenu,
  },

  props: {
    form: { type: Object, required: true },
  },

  data() {
    return {
      showMore: false,
    };
  },

  computed: {
    submitUrl() {
      const { accountId } = this.$route.params;
      return `https://app.digi-mate.eu/api/v1/accounts/${accountId}/contact-form`;
    },
    jsonStructure() {
      const { uuid: formUuid } = this.form;
      const { projectId: projectUuid = null } = this.$route.params;
      return `
{
  "formUuid": "${formUuid}",
  "projectUuid": "${projectUuid}",
  "pageUuid": "INSERT PAGE ID OR REMOVE FIELD",
  "pageUrl": "[_url]",
  "firstName": "[FNAME]",
  "lastName": "[LNAME]",
  "email": "[EMAIL]",
  "phone": "[PHONE]",
  "notes": "[NOTES]",
  "customFields": {
    "utm_source": {
      "name": "utm source",
      "value": "[utm_source]"
    },
    "utm_medium": {
      "name": "utm medium",
      "value": "[utm_medium]"
    },
    "utm_campaign": {
      "name": "utm campaign",
      "value": "[utm_campaign]"
    },
    "utm_content": {
      "name": "utm content",
      "value": "[utm_content]"
    },
    "gdpr_approved": {
      "name": "gdpr approved",
      "value": "[GDPR_APPROVED]"
    }
  }
}`;
    },
  },
};
</script>
